import { Button, ButtonsGroup, Checkbox, Modal, ModalProps, Space, Text, useModal } from '@billy/design-system'
import { ReactElement, useCallback, useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'

export interface AnnualReportLateWarningModalProps extends ModalProps {
  onConfirm: () => void
}

export const AnnualReportLateWarningModal = ({
  onConfirm,
  ...modalProps
}: AnnualReportLateWarningModalProps): ReactElement => {
  const { t } = useTranslation()
  const { close } = useModal(modalProps.id)
  const [confirmed, setConfirmed] = useState(false)

  const handleConfirm = useCallback(() => {
    close()
    onConfirm()
  }, [close, onConfirm])

  const handleReject = useCallback(() => {
    close()
  }, [close])

  const handleCheckboxChange = () => setConfirmed((currentValue) => !currentValue)

  return (
    <Modal {...modalProps} size="s" closable>
      <Modal.Header>
        <Text variant="h2">{t('annual_report.late_warning_modal.heading')}</Text>
      </Modal.Header>
      <Modal.Body>
        <Text variant="bodyLG">
          <Trans i18nKey="annual_report.late_warning_modal.body" components={{ br: <br /> }} />
        </Text>
        <Space size="s24" />
        <Checkbox checked={confirmed} onChange={handleCheckboxChange}>
          <Trans i18nKey="annual_report.late_warning_modal.checkbox_label" />
        </Checkbox>
      </Modal.Body>
      <Modal.Footer>
        <ButtonsGroup>
          <Button variant="text" onClick={handleReject}>
            {t('annual_report.late_warning_modal.reject_cta')}
          </Button>
          <Button variant="filled" onClick={handleConfirm} disabled={!confirmed}>
            {t('annual_report.late_warning_modal.confirm_cta')}
          </Button>
        </ButtonsGroup>
      </Modal.Footer>
    </Modal>
  )
}
